export default __webpack_public_path__ + "static/media/title.9bde2dd9.jpg";